const mixin = {
  mounted () {
    this.checkoutTheme()
  },


  methods: {
    onChangeTheme () {
      localStorage.setItem('themeDark', this.$vuetify.theme.dark.toString())
    },

    checkoutTheme () {
      if (localStorage.getItem('themeDark') === 'true') {
        this.$vuetify.theme.dark = true
      } else {
        this.$vuetify.theme.dark = false
      }
    }
  }
}

export default mixin
